import './RepeatingName.css';

const RepeatingName = () => {
	return (
		<div className="name-container">
			<div id="opacity-gradient"></div>
			<div id="repeating-name"></div>
		</div>
	);
}

export default RepeatingName;
